import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58dfb2a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-6 p-4 container mx-auto" }
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = { class: "flex gap-4 justify-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Kategorier", -1))
const _hoisted_5 = { class: "gap-8" }
const _hoisted_6 = { class: "w-full divide-y" }
const _hoisted_7 = {
  key: 0,
  class: "empty-categories"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Ingen FAQ kategorier funnet!", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Start med å legge til nye", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import {computed, onMounted, onUnmounted, ref, watch,} from "vue";
import CategoryForm from "@/Components/FAQCategories/CategoryForm.vue";
import HcButton from "@/Components/Buttons/Button.vue";
import {throttle} from "lodash";
import Card from "@/Components/General/Card.vue";
import CardBody from "@/Components/General/CardBody.vue";
import route from "ziggy-js"

//@ts-ignore
import * as tailwindConfig from "../../../../tailwind.config.mjs";
import {Option} from "@/types/LevelsSelectTypes";
import FaqCategory from "@/types/FaqCategory";
import {Inertia} from "@inertiajs/inertia";
import Messages from "@/Components/General/Messages.vue";


interface Props {
  categories: FaqCategory[];
}


import AppLayoutVue from "@/Layouts/AppLayout.vue";


const __default__ = {
  layout: AppLayoutVue,

}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  ...{
},
  __name: 'Categories',
  props: {
    categories: {}
  },
  setup(__props: any) {

const props: Props = __props;




const selectedOptionId = ref(null);
const createNew = ref(route().current("faq-categories.create"));
const screenWidth = ref(window.innerWidth);

watch(
  () => selectedOptionId.value,
  function () {
    if (selectedOptionId.value) {
      createNew.value = false;
    }
  }
);


function mapCategories(categories: FaqCategory[], levels: number): Option[] {

  if (levels == 0) {
    return [];

  }
  return categories.map((category: FaqCategory) => ({
    id: category.id,
    label: category.title,
    parent_id: category.parent_id,
    expandable: category.sub_categories && category.sub_categories.length > 0,
    options: category.sub_categories ? mapCategories(category.sub_categories, levels - 1) : [],
  }))
}

const options = mapCategories(props.categories as any, 3);
const selectCategory = () => {

    Inertia.visit(
      route("faq-categories.show", selectedOptionId.value as any) +
      window.location.search,
      {}
    );

}

watch(
  () => selectedOptionId.value,
  function () {
    if (selectedOptionId.value) {
      selectCategory();
    }
  }
);
const onDeleted = () => {
  Inertia.visit(route("faq-categories.index"));
};



const onResize = throttle((e) => {
  screenWidth.value = e.target.innerWidth;
}, 100);

onMounted(() => {
  window.addEventListener("resize", onResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});



return (_ctx: any,_cache: any) => {
  const _component_levels_select = _resolveComponent("levels-select")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Messages, { class: "attribute-index-messages" }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _createVNode(HcButton, {
            color: "green",
            type: "inertia-link",
            href: _unref(route)('faq-categories.create'),
            disabled: 
              _unref(route)().current('faq-categories.create')
            
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ny kategori ")
            ]),
            _: 1
          }, 8, ["href", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (!_unref(options).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
            : (_openBlock(), _createBlock(_component_levels_select, {
                key: 1,
                options: _unref(options),
                limit: 100,
                modelValue: selectedOptionId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOptionId).value = $event)),
                placeholder: "Velg kategori",
                open: true
              }, null, 8, ["options", "modelValue"]))
        ])
      ])
    ])
  ]))
}
}

})